import axios from "axios";

export const getFeaturedJobDisplay = (careersClientId) => {
  return axios
    .get(
      import.meta.env.VITE_ACTIVATE_BACKEND_API +
        "/api/featuredjobdetaildisplay/" +
        encodeURIComponent(careersClientId)
    )
    .then((res) => res.data);
};

export const editFeaturedJobDisplay = (careersClientId, data) => {
  return axios
    .post(
      import.meta.env.VITE_ACTIVATE_BACKEND_API +
        "/api/featuredjobdetaildisplay/editfeaturedjobdetailconfiguration/" +
        encodeURIComponent(careersClientId),
      data
    )
    .then((res) => res.data);
};
